import(/* webpackMode: "eager" */ "/root/ophirstudio_next/app/[lang]/loading.tsx");
